//require('./bootstrap');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import axios from 'axios';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';

// Make Swiper available globally for inline scripts if needed
window.Swiper = Swiper;

// Initialize Swiper on pages where the container exists
document.addEventListener('DOMContentLoaded', () => {
    const swiperContainer = document.querySelector('.main-banner-swiper');
    if (!swiperContainer || typeof Swiper === 'undefined') return;

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper('.main-banner-swiper', {
        modules: [Pagination, EffectFade, Autoplay],
        loop: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 850,
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        pagination: {
            el: '.main-banner-swiper .swiper-pagination',
            clickable: true,
        },
        // navigation: {
        //     nextEl: '.main-banner-swiper .swiper-button-next',
        //     prevEl: '.main-banner-swiper .swiper-button-prev',
        // },
    });
});

// Function to get localized text
function getLocalizedText(key) {
    const translations = {
        'ru': {
            'in_cart': 'В корзине'
        },
        'uk': {
            'in_cart': 'У кошику'
        }
    };

    const locale = window.currentLocale || 'uk';
    return translations[locale] && translations[locale][key] ? translations[locale][key] : translations['uk'][key];
}

$(document).on("change paste", '.check-qty', function () {

    var id = $(this).attr("data-id");
    var idqty = $('.check-qty[data-id=' + id + ']').val();

    if (idqty == 0 || idqty == '') {
        idqty = 1;
    }

    $(this)[0].value = idqty;

});

$(document).on('change', "#sort", function (e) {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    let order = $('#sort :selected').val();

    let page = 1;
    var cat_id = $('.catid').attr("id");

    getProducts(page, cat_id);
});

$(document).on('change', "#stock", function (e) {

    let stock = $('#stock :selected').attr("descr");

    $("#stock_descr").fadeOut(function () {
        $(this).html(stock).fadeIn();
    });

});

// Generic navigation for buttons/links with data-url
$(document).on('click', '.js-nav-by-url', function (e) {
    e.preventDefault();
    const url = $(this).data('url');
    if (!url) {
        return;
    }
    const target = $(this).data('target');
    if (target === '_blank') {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) {
            newWindow.opener = null;
        }
        return;
    }

    window.location.href = url;
});

$(document).on('click', ".add-to-cart", function () {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    var dataid = $(this).attr("data-id");

    $.ajax({
        url: "/addtocart",
        //url:"{{route('addToCart')}}",
        method: 'POST',
        data: {
            id: dataid,
        },
        success: function (data) {

            // var qtyall = 0;
            // $(".inputchange").each(function() {
            //     qtyall = qtyall + parseInt($(this).val());
            //
            // });
            // $("#cart").attr('data-totalitems', qtyall);

            // $('#modal-body-cart').html(data);
            // $('#cart_modal_add').modal('show');

            $('.cart-counter').html(data.count);
            $('.mobile-cart-counter').html(data.count);

            // Изменяем кнопку на локализованный текст "В корзине"/"У кошику" с галочкой
            var $button = $('.add-to-cart[data-id="' + dataid + '"]');
            var $btnBorder = $button.closest('.btn-border');




            // Заменяем весь контент контейнера (убираем SVG плюс и кнопку, создаем новую кнопку)
            $btnBorder.html('<button class="btn btn-orange fw-semibold in-cart" data-id="' + dataid + '">' + getLocalizedText('in_cart') + '</button>');

            // Загружаем содержимое корзины и открываем модальное окно
            $.ajax({
                url: '/cart-ajax',
                method: 'POST',
                data: {
                    locale: window.currentLocale || 'uk'
                },
                beforeSend: function () {
                    $('.loading-overlay').show();
                },
                success: function (result) {
                    $('#modal-body-cart').html(result);
                    $('.loading-overlay').fadeOut("slow");

                    // Открываем модальное окно корзины (Bootstrap 5)
                    $('#cartModal').modal('show');
                },
                error: function (data) {
                    $('.loading-overlay').fadeOut("slow");
                    console.error('Ошибка при загрузке корзины:', data);
                }
            });

        },
        error: function (data) {
            console.log(data);
        }
    });
});

$(document).on('click', ".add-to-cart-with-quantity", function () {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    var dataid = $(this).attr("data-id");

    // Получаем количество из input поля в модальном окне
    var quantity = 1; // значение по умолчанию
    var $modal = $(this).closest('.modal');
    var $qtyInput = $modal.find('.product-modal__qty-input');

    if ($qtyInput.length) {
        quantity = parseInt($qtyInput.val()) || 1;
    }

    $.ajax({
        url: "/addtocart-with-quantity",
        //url:"{{route('addToCart')}}",
        method: 'POST',
        data: {
            id: dataid,
            quantity: quantity,
        },
        success: function (data) {

            $('.cart-counter').html(data.count);
            $('.mobile-cart-counter').html(data.count);

            // Изменяем кнопку на локализованный текст "В корзине"/"У кошику" с галочкой
            var $button = $('.add-to-cart[data-id="' + dataid + '"]');
            var $btnBorder = $button.closest('.btn-border');

            // Заменяем весь контент контейнера (убираем SVG плюс и кнопку, создаем новую кнопку)
            $btnBorder.html('<button class="btn btn-orange fw-semibold in-cart" data-id="' + dataid + '">' + getLocalizedText('in_cart') + '</button>');

            // Закрываем модальное окно после успешного добавления
            var $modal = $('.modal.show');
            if ($modal.length) {
                $modal.modal('hide');
            }

        },
        error: function (data) {
            console.log(data);
        }
    });
});

$(document).ready(function () {



    // $(window).on('load', function () {
    //
    //     $('#js-preloader').addClass('loaded');
    //
    // });

    $('.show-hide').click(function () {
        $(this).next().toggleClass('toggle');
    });

    // Обработчики для кнопок изменения количества в модальном окне
    // $(document).on('click', '.product-modal__qty-btn--plus', function () {
    //     var $input = $(this).closest('.product-modal__qty-input-group').find('.product-modal__qty-input');
    //     var currentValue = parseInt($input.val()) || 1;
    //     var maxValue = parseInt($input.attr('max')) || 999;

    //     if (currentValue < maxValue) {
    //         $input.val(currentValue + 1);
    //         // Обновляем data-quantity кнопки добавления в корзину
    //         updateAddToCartButtonQuantity($input);
    //     }
    // });

    // $(document).on('click', '.product-modal__qty-btn--minus', function () {
    //     var $input = $(this).closest('.product-modal__qty-input-group').find('.product-modal__qty-input');
    //     var currentValue = parseInt($input.val()) || 1;

    //     if (currentValue > 1) {
    //         $input.val(currentValue - 1);
    //         // Обновляем data-quantity кнопки добавления в корзину
    //         updateAddToCartButtonQuantity($input);
    //     }
    // });

    // // Обработчик для прямого ввода в поле количества
    // $(document).on('input change', '.product-modal__qty-input', function () {
    //     var $input = $(this);
    //     var value = parseInt($input.val()) || 1;
    //     var maxValue = parseInt($input.attr('max')) || 999;
    //     var minValue = parseInt($input.attr('min')) || 1;

    //     // Валидация значения
    //     if (value < minValue) {
    //         $input.val(minValue);
    //         value = minValue;
    //     } else if (value > maxValue) {
    //         $input.val(maxValue);
    //         value = maxValue;
    //     }

    //     // Обновляем data-quantity кнопки добавления в корзину
    //     updateAddToCartButtonQuantity($input);
    // });

    // // Функция для обновления data-quantity кнопки добавления в корзину
    // function updateAddToCartButtonQuantity($input) {
    //     var quantity = parseInt($input.val()) || 1;
    //     var $modal = $input.closest('.modal');
    //     var $addButton = $modal.find('.add-to-cart-with-quantity');

    //     if ($addButton.length) {
    //         $addButton.attr('data-quantity', quantity);
    //     }
    // }

    // $('.slresp').slick({
    //     dots: false,
    //     arrows: true,
    //     //infinite: true,
    //     speed: 2000,
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //     responsive: [
    //         {
    //             breakpoint: 1024,
    //             settings: {
    //                 slidesToShow: 3,
    //                 slidesToScroll: 1,
    //                 // infinite: true,
    //                 // dots: true
    //             }
    //         },
    //         {
    //             breakpoint: 600,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 1
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1
    //             }
    //         }
    //     ]
    // });
});


$(document).on('click', ".pagination a", function (e) {
    e.preventDefault();

    var selected = [];
    $('#checkboxes input:checked').each(function () {
        selected.push($(this).attr('id'));
    });

    var selected_groups = [];
    $('#cb-group input:checked').each(function () {
        selected_groups.push($(this).attr('id'));
    });

    if ((selected.length === 0) && (selected_groups.length === 0)) {
        window.location = this.href;
    } else {

        var page = $(this).attr('href').split('page=')[1];

        var cat_id = $('.catid').attr("id");

        history.pushState(null, null, '?page=' + page + '&brands=' + selected + '&groups=' + selected_groups);
        getProducts(page, cat_id);
        $("html, body").animate({ scrollTop: 0 }, "slow");
    }

    // $('li').removeClass('active');
    // $(this).parent('li').addClass('active');

});

// Обработчик для модального окна rashod
// $(document).on('click', '[data-bs-target="#rashod"]', function (e) {
//     e.preventDefault();

//     var rashodNumber = $(this).attr('data-rashod-number');
//     var rashodDate = $(this).attr('data-rashod-date');

//     $.ajaxSetup({
//         headers: {
//             'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
//         }
//     });
//     $.ajax({
//         url: '/rashod-details',
//         method: 'POST',
//         data: {
//             rashod_number: rashodNumber,
//             rashod_date: rashodDate
//         },
//         success: function (result) {
//             $('#rashod_details').html(result);
//         },
//         error: function (data) {
//             console.log('Error loading rashod details:', data);
//         }
//     });
// });

// $(document).on('click', '.getRashod', function (e) {
//     e.preventDefault();

//     $.ajaxSetup({
//         headers: {
//             'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
//         }
//     });
//     $.ajax({
//         url: '/rashod-details',
//         method: 'POST',
//         data: {
//             rashod_number: $(this).attr("id"),
//             rashod_date: $(this).attr("date")
//         },
//         success: function (result) {
//             $('#rashod_details').html(result);
//         },
//         error: function (data) {
//         }
//     });
// });

$(function () {
    $('[data-toggle="popover"]').popover()
})

// $('.check-stock').popover({
//     title: "Наличие по складам",
//     placement: 'bottom',
//     trigger: 'click',
//     html: true,
//     content: function () {
//         return "<i class='fa fa-spinner fa-pulse fa-2x fa-fw'></i>"
//     }
// });

$(document).on('click', '.check-stock', function (e) {
    e.preventDefault();

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $.ajax({
        url: '/check-left-over',
        method: 'POST',
        data: {
            id: $(this).attr("id")
        },
        success: function (result) {
            $('.popover-body').html(result);
        },
        error: function (data) {
        }
    });
});

$(document).on('change', '.brand-filter', function () {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    var cat_id = $('.catid').attr("id");
    var selected = [];

    $('#checkboxes input:checked').each(function () {
        selected.push($(this).attr('id'));
    });

    var selected_groups = [];
    $('#cb-group input:checked').each(function () {
        selected_groups.push($(this).attr('id'));
    });

    if ((selected.length === 0) && (selected_groups.length === 0)) {
        window.location = window.location.pathname;
        return false;
    }

    //let status = $(this).val();
    let page = 1;
    history.pushState(null, null, '?page=' + page + '&brands=' + selected + '&groups=' + selected_groups);

    getProducts(page, cat_id);

});

function getProducts(page, cat_id) {

    var selected = [];
    $('#checkboxes input:checked').each(function () {
        selected.push($(this).attr('id'));
    });

    var selected_groups = [];
    $('#cb-group input:checked').each(function () {
        selected_groups.push($(this).attr('id'));
    });

    let order = $('#sort :selected').val();
    //let order = 'asc';
    //console.log(order);
    $.ajax({
        url: "/category/" + cat_id + "?page=" + page + '&brands=' + selected + '&groups=' + selected_groups + '&order=' + order,
        method: "GET",
        //data:{selected:selected},
        beforeSend: function () {
            $('.loading-overlay').show();
        },
        success: function (data) {
            //console.log($("#sort").val(order));
            $('#dataContainer').html(data);
            $("#sort option[value=" + order + "]").attr('selected', 'selected');
            $('.loading-overlay').fadeOut("slow");

        }
    });
}

$(document).ready(function () {
    $('#saveVin').on('submit', function (e) {
        e.preventDefault();
        $('.vin-error').removeClass('ph_color').html('');
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            url: '/vin',
            method: 'POST',
            data: {
                Телефон: $('#vin_phone').val(),
                Vin: $('#vin_code').val(),
                Описание: $('#vin_comment').val()
            },
            success: function (result) {
                $('#saveVin').hide();
                $('#vin_success_message').html(result).show();
            },
            error: function (data) {
                $('#vin_phone_error').addClass('ph_color').html(data.responseJSON.errors.Телефон);
                $('#vin_code_error').addClass('ph_color').html(data.responseJSON.errors.Vin);
                $('#vin_comment_error').addClass('ph_color').html(data.responseJSON.errors.Описание);
            }
        });
    });

    $('#saveorder').on('submit', function (e) {
        e.preventDefault();

        var radio_id;
        radio_id = $('input[name="radio"]:checked').attr('id');
        var selfPickup;
        selfPickup = $('#selfPickup').val();
        var newPostDelivery;
        newPostDelivery = $('#newPostDelivery').val();
        var cityDelivery;
        cityDelivery = $('#cityDelivery').val();
        const $stockRadio = $('input[name="stock_name"]:checked');
        const stockName = $stockRadio.val() || '';
        const stock = stockName;

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            url: '/saveorder',
            method: 'POST',
            data: {
                Имя: $('#username').val(),
                Телефон: $('#userPhone').val(),
                //userComment: $('#userComment').val(),
                radio: radio_id,
                selfPickup: selfPickup,
                stock: stock,
                newPostDelivery: newPostDelivery,
                cityDelivery: cityDelivery,
                stock_name: stockName
            },
            beforeSend: function () {
                $('.loading-overlay').show();
            },
            success: function (result) {
                $('.cart').html(result);
                $("html, body").animate({ scrollTop: 0 }, "slow");
                $('.loading-overlay').fadeOut("slow");
            },
            error: function (data) {
                //console.log(data.responseJSON);
                $('#username_error').addClass('ph_color').html(data.responseJSON.errors.Имя);
                $('#userphone_error').addClass('ph_color').html(data.responseJSON.errors.Телефон);
                //$('#userComment_error').addClass('ph_color').html(data.responseJSON.errors.userComment);
            }
        });
    });

    // Кастомная обработка контактной формы
    $('#contact-form').on('submit', function (e) {
        e.preventDefault();

        const $form = $(this);
        const formData = new FormData(this);

        // Очищаем предыдущие ошибки
        $form.find('.error-message').remove();
        $form.find('.is-invalid').removeClass('is-invalid');

        // Восстанавливаем оригинальные labels
        $form.find('label.error-label').each(function () {
            const $label = $(this);
            const originalText = $label.data('original-text');
            if (originalText) {
                $label.text(originalText).removeClass('error-label');
            }
        });

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $.ajax({
            url: '/contactsave',
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function () {
                $('.loading-overlay').show();
                $form.find('button[type="submit"]').prop('disabled', true);
            },
            success: function (result) {
                // Заменяем содержимое формы на результат
                $form.html(result);

                // Показываем уведомление об успехе
                //showNotification('Сообщение успешно отправлено!', 'success');
            },
            error: function (xhr) {
                if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
                    // Обработка ошибок валидации
                    const errors = xhr.responseJSON.errors;

                    Object.keys(errors).forEach(function (fieldName) {
                        const $field = $form.find(`[name="${fieldName}"]`);
                        const errorMessages = errors[fieldName];

                        if ($field.length) {
                            // Добавляем класс ошибки к полю
                            $field.addClass('is-invalid');

                            // Находим соответствующий label
                            const $label = $form.find(`label[for="${$field.attr('id')}"]`);
                            if ($label.length) {
                                // Сохраняем оригинальный текст label если еще не сохранен
                                if (!$label.data('original-text')) {
                                    $label.data('original-text', $label.text());
                                }

                                // Заменяем текст label на сообщение об ошибке
                                $label.text(errorMessages.join(', ')).addClass('error-label');
                            } else {
                                // Если label не найден, создаем элемент ошибки
                                const errorHtml = `<div class="error-message text-danger small mt-1">${errorMessages.join(', ')}</div>`;
                                const $wrapper = $field.closest('.contact-input-group, .contact-textarea-group, .form-group');
                                if ($wrapper.length) {
                                    $wrapper.append(errorHtml);
                                } else {
                                    $field.after(errorHtml);
                                }
                            }
                        }
                    });
                } else {
                    // Общая ошибка
                    const errorMessage = xhr.responseJSON?.message || 'Произошла ошибка при отправке формы';
                    showNotification(errorMessage, 'error');
                }
            },
            complete: function () {
                $('.loading-overlay').fadeOut('slow');
                $form.find('button[type="submit"]').prop('disabled', false);
            }
        });
    });

    //////////////////////////////////////

    $('#balanceUpdate').on('click', function (e) {
        e.preventDefault();

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            url: '/balanceupdate',
            method: 'POST',
            data: {
                start_date: $('#start_date').val(),
                end_date: $('#end_date').val()
            },
            success: function (result) {
                $('#balanceDate').html(result);
            },
            error: function (data) {
            }
        });
    });



});

// Функция показа уведомлений
function showNotification(message, type = 'info') {
    // Удаляем предыдущие уведомления
    $('.notification').remove();

    const typeClass = type === 'success' ? 'alert-success' :
        type === 'error' ? 'alert-danger' :
            type === 'warning' ? 'alert-warning' : 'alert-info';

    const notification = $(`
        <div class="notification alert ${typeClass} alert-dismissible fade show position-fixed"
             style="top: 20px; right: 20px; z-index: 9999; min-width: 300px;">
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
    `);

    $('body').append(notification);

    // Автоматически скрываем через 5 секунд
    setTimeout(() => {
        notification.alert('close');
    }, 5000);
}

// Функция обновления корзины
function updateCartQuantity(element) {
    var id = $(element).attr("data-id");
    var idqty = $(element).val();

    // Проверяем максимальное количество
    var maxQty = $(element).attr('max');
    if (maxQty && parseInt(idqty) > parseInt(maxQty)) {
        showNotification('Максимальное количество товара: ' + maxQty, 'warning');
        $(element).val(maxQty);
        idqty = maxQty;
    }

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $.ajax({
        url: '/update-cart',
        method: 'POST',
        data: {
            id: id,
            qty: idqty,
            locale: window.currentLocale || 'uk' // Передаем текущую локаль
        },
        beforeSend: function () {
            window.isUpdatingCart = true;
            $('.loading-overlay').show();
        },
        success: function (result) {

            //window.location.reload();
            $('#modal-body-cart').html(result);

            // var qtyall = 0;
            // $(".inputchange").each(function () {
            //     qtyall = qtyall + parseInt($(this).val());

            // });

            // $("#cart").attr('data-totalitems', qtyall);
            // $('.loading-overlay').fadeOut("slow");

            // var sum = 0;
            // $('.price-tag-sm').each(function () {
            //     sum += parseFloat($(this).html());  // Or this.innerHTML, this.innerText
            // });
            // $(".total-sum").html(sum.toFixed(2));

        },
        error: function (data) {
            //console.log(data);
        },
        complete: function () {
            window.isUpdatingCart = false;
        }
    });
}

$(document).on("change paste", '.inputchange', function () {
    updateCartQuantity(this);
});

// Добавляем обработчик для нажатия Enter
$(document).on("keypress", '.inputchange', function (e) {
    if (e.which == 13) { // Enter key
        e.preventDefault();
        updateCartQuantity(this);
    }
});

// Строгая валидация при вводе
$(document).on("input keyup blur", '.inputchange', function () {
    var maxQty = $(this).attr('max');
    var currentValue = parseInt($(this).val()) || 0;

    // Проверяем, что значение не пустое и является числом
    if (isNaN(currentValue) || currentValue < 1) {
        $(this).val(1);
        updateCartQuantity(this);
        return;
    }

    if (maxQty && currentValue > parseInt(maxQty)) {
        showNotification('Максимальное количество товара: ' + maxQty, 'warning');
        $(this).val(maxQty);
        updateCartQuantity(this);
    }
});


// $(document).on("click", '.btn-trash', function () {

//     if (confirm("Видалити товар з кошику?")) {
//         var id = $(this).attr("id");

//         $.ajaxSetup({
//             headers: {
//                 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
//             }
//         });

//         $.ajax({
//             url: '/remove',
//             method: 'POST',
//             data: {
//                 id: id,

//             },
//             beforeSend: function () {
//                 $('.loading-overlay').show();
//             },
//             success: function (result) {

//                 window.location.reload();

//                 // $('#cart-render').html(result);
//                 // var qtyall = 0;
//                 // $(".inputchange").each(function() {
//                 //     qtyall = qtyall + parseInt($(this).val());
//                 //
//                 // });
//                 // $("#cart").attr('data-totalitems', qtyall);
//                 // $('.loading-overlay').fadeOut("slow");

//             },
//             error: function (data) {
//             }
//         });
//         return false;
//     }


// });

// Функция для сброса формы контактов
window.resetContactForm = function () {
    // Находим форму контактов
    const $contactForm = $('.contact-form');

    if ($contactForm.length) {
        // Очищаем все поля формы
        $contactForm.find('input[type="text"], input[type="email"], input[type="tel"], textarea').val('');

        // Убираем классы ошибок
        $contactForm.find('.is-invalid').removeClass('is-invalid');
        $contactForm.find('.error-message').remove();

        // Восстанавливаем оригинальные labels
        $contactForm.find('label.error-label').each(function () {
            const $label = $(this);
            const originalText = $label.data('original-text');
            if (originalText) {
                $label.text(originalText).removeClass('error-label');
            }
        });

        // Загружаем оригинальную форму через AJAX
        $.ajax({
            url: '/contact-form-reset',
            method: 'GET',
            success: function (result) {
                $contactForm.html(result);
            },
            error: function () {
                // Если не удалось загрузить, просто очищаем форму
                $contactForm.find('input, textarea').val('');
            }
        });
    }
}


